export { default as adminRoutes } from "./admin-routes";
